import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectedMetricSelector } from '@store/metricsChartContainer/selectors';
import {
  ECO_EXCESSIVE_APP_RESTART_DIMENSIONS,
  excessiveAppRestartMetrics,
} from '@utils/dimension/appDimensionHelper';
import { tid } from '@utils/test';
import AppDimensionTable from '../AppDimensionTable';
import { DimensionTableWrapper, DimensionTitle } from '../styled';
import { TABLE_HEIGHT_MAPPING } from '../../header/Resize';
import { allDimensionsListSelector } from '@src/store/common/dimensionList/selectors';

function ExcessiveAppRestartWidget() {
  const selectedMetric = useSelector(selectedMetricSelector);
  if (!excessiveAppRestartMetrics.includes(selectedMetric)) {
    return null;
  }
  return (
    <>
      {ECO_EXCESSIVE_APP_RESTART_DIMENSIONS.map((options) => {
        return (
          <DimensionTableWidget
            header={options.header}
            dimension={options.dimension}
            key={options.dimension}
          />
        );
      })}
    </>
  );
}

const DimensionTableWidget: React.FC<{ header: string; dimension: string }> = (props) => {
  const { header, dimension } = props;
  const [gridRow, updateGrid] = useState(TABLE_HEIGHT_MAPPING.s);

  const supportedDimension = useSelector(allDimensionsListSelector) as any[];
  // disable drill down if this dimension is not in supported dimension list
  const disableDrilldown = supportedDimension.every((it) => it.groupBy !== dimension);
  const dndStyle = {
    gridRow: `span ${gridRow}`,
  };
  return (
    <DimensionTableWrapper
      id={dimension}
      style={dndStyle}
      {...tid(`dimension-table::${dimension}`)}
    >
      <DimensionTitle>{header}</DimensionTitle>
      <AppDimensionTable
        dimension={dimension}
        updateGrid={updateGrid}
        disableDrilldown={disableDrilldown}
      />
    </DimensionTableWrapper>
  );
};

export default ExcessiveAppRestartWidget;
